import { axiosInstance } from '@/api/constants.ts';
import { ApiCustomer, ApiCustomerImage } from '@/api/types.ts';

export type CustomerLoginRequest = {
  email: string;
  password: string;
  cart_uuid?: string | null;
};

export type CustomerLoginResponse = {
  access_token: string;
};

export async function loginCustomer(body: CustomerLoginRequest) {
  const { data } = await axiosInstance.post<CustomerLoginResponse>(
    '/api/customer/login',
    body,
  );
  return data;
}

export async function logoutCustomer() {
  const { data } = await axiosInstance.post('/api/customer/logout');
  return data;
}

export type CustomerRegisterRequest = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string | null;
  password: string;
  cart_uuid?: string | null;
  newsletter: boolean;
};

export type CustomerRegisterResponse = {
  access_token: string;
  customer: ApiCustomer;
};

export async function registerCustomer(body: CustomerRegisterRequest) {
  const { data } = await axiosInstance.post<CustomerRegisterResponse>(
    '/api/customer/register',
    body,
  );
  return data;
}

export type ForgotCustomerPasswordRequest = {
  email: string;
};

export async function forgotCustomerPassword(
  body: ForgotCustomerPasswordRequest,
) {
  const { data } = await axiosInstance.post(
    '/api/customer/forgot-password',
    body,
  );
  return data;
}

export type ResetCustomerPasswordRequest = {
  token: string;
  new_password: string;
};

export async function resetCustomerPassword(
  body: ResetCustomerPasswordRequest,
) {
  const { data } = await axiosInstance.post(
    '/api/customer/reset-password',
    body,
  );
  return data;
}

export async function getCurrentCustomer(): Promise<ApiCustomer> {
  const { data } = await axiosInstance.get<ApiCustomer>('/api/customer');
  return data;
}

export type GetCustomerImagesResponse = {
  data: ApiCustomerImage[];
  count: number;
};

export async function getCustomerImages(
  limit = -1,
): Promise<GetCustomerImagesResponse> {
  const { data } = await axiosInstance.get<GetCustomerImagesResponse>(
    '/api/customer/images?limit=' + limit,
  );
  return data;
}

export async function deleteCustomerImage(
  customerImageId: number,
): Promise<void> {
  const { data } = await axiosInstance.delete<void>(
    `/api/customer/images/${customerImageId}`,
  );
  return data;
}

export async function usedCustomerImage(
  customerImageId: number,
): Promise<void> {
  const { data } = await axiosInstance.post<void>(
    `/api/customer/images/${customerImageId}/used`,
  );
  return data;
}
